import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import AptitudeTestQuestion from 'src/entities/AptitudeTestQuestion';
import { ApiAptitudeTestChoiceResponse } from 'src/services/entity-factory/factories/AptitudeTestChoiceFactory';

export interface ApiTestQuestionResponse {
  id: number;
  statement: string;
  choices: ApiAptitudeTestChoiceResponse[];
}

interface ApiAptitudeTestQuestionCreateRequest {
}

export class AptitudeTestQuestionFactory extends BaseFactory<AptitudeTestQuestion> {
  public toEntity(args: ApiTestQuestionResponse): AptitudeTestQuestion {
    return new AptitudeTestQuestion({
      id: args.id,
      statement: args.statement,
      choices: args.choices ?
        args.choices.map(
          choice => this.entityFactoryFactory.aptitudeTestChoiceFactory.toEntity(choice)
        ) : [],
    });
  }

  public toRequest(aptitudeTestQuestion: AptitudeTestQuestion): ApiAptitudeTestQuestionCreateRequest {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/AptitudeTestQuestionFactory.tsx